import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import loc from '@/locales';
import { onMounted, onUpdated, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TipComponent',
  setup(__props) {

const variable = ref(0)

function getRandomTip(){
  return Math.floor(Math.random() * loc.locales.value.tips.length)
}

onMounted(() => {
  variable.value = getRandomTip()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, _toDisplayString(_unref(loc).locales.value.tipName) + ": " + _toDisplayString(_unref(loc).locales.value.tips[variable.value]), 1))
}
}

})